module.exports = __webpack_public_path__ + "static/media/icon-copy.d45ce5c8.svg";